<script lang="ts">
    import { onMount } from "svelte";

    import { Datatable } from "svelte-simple-datatables";
    import Fa from "svelte-fa";
    import { faXmark, faCheck } from "@fortawesome/free-solid-svg-icons";
    import type { PlayerListEntry } from "../../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../../GlobalHelper/ApiClient";
    import { user } from "../../../../../store/stores";

    export let selectedPlayers: PlayerListEntry[];
    export let onSelect: (players: PlayerListEntry[]) => void;
    export let onDeselect: (players: PlayerListEntry[]) => void;

    const settings = {};
    let rows;
    let data;

    const getStations = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .locationClient.listGeoLocationsOfAllLocations({})
                .then((locations) => (data = locations));
        });
    };

    $: checked = (row) =>
        selectedPlayers.findIndex((item) => {
            return item.id === row.id;
        }) !== -1;

    onMount(() => {
        getStations();
    });
</script>

{#if data && selectedPlayers}
    <div class="table-wrapper">
        <Datatable {settings} {data} bind:dataRows={rows}>
            <thead>
                <th data-key="selected" />
                <th data-key="name">Station</th>
            </thead>
            <tbody>
                {#if rows}
                    {#each $rows as row}
                        <tr>
                            <td>
                                <input
                                    type="checkbox"
                                    checked={checked(row)}
                                    on:click={() => {
                                        console.log(checked(row));
                                        checked(row)
                                            ? onDeselect([row])
                                            : onSelect([row]);
                                    }}
                                />
                            </td><td>{row.name}</td>
                        </tr>
                    {/each}
                {/if}
            </tbody>
        </Datatable>
        {selectedPlayers.length}
    </div>
{/if}

<style>
    .table-wrapper {
        padding-top: 2rem;
        min-height: 35rem;
    }
</style>
